var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('svg',{class:_vm.classes,style:(_vm.styles)},[_c('use',_vm._b({},'use',{'href':'#icon-tx4_'+ _vm.usedIcon},false))])
}
var staticRenderFns = []

export { render, staticRenderFns }